<template lang="pug">
v-dialog(
    v-model="showModal"
    :max-width='maxWidth',
    :persistent='persistent',
    @click:outside="closeDialog()"
  ).d-flex.justify-center.align-center.border
    v-card( :style='{ borderRadius: borderRadius }').simple-modal
      PerfectScrollbar
        v-card-text
          slot(name='content')
      v-card-actions.actions-style
        v-btn.elevation-0(
          width="100px"
          v-if='showLButton'
          @click='$emit("clickLButton")',
          :color='lButtonColor').white-text {{ lButtonTitle }}
        v-spacer
        v-btn.elevation-0(
          width="100px"
          v-if='showRButton'
          @click='$emit("clickRButton")',
          :color='rButtonColor',
          style="margin-l: 1rem;").white-text {{ rButtonTitle }}
</template>

<script>
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  components: {
    PerfectScrollbar
  },
  props: {
    lButtonMethod: {
      type: Function,
      default: () => {
      }
    },
    rButtonMethod: {
      type: Function,
      default: () => {
      }
    },
    lButtonTitle: {
      type: String,
      default: () => ''
    },
    rButtonTitle: {
      type: String,
      default: () => ''
    },
    borderRadius: {
      type: String,
      default: () => '4px'
    },
    showLButton: {
      type: Boolean,
      default: () => false
    },
    showRButton: {
      type: Boolean,
      default: () => false
    },
    lButtonColor: {
      type: String,
      default: () => 'white'
    },
    rButtonColor: {
      type: String,
      default: () => 'white'
    },
    persistent: {
      type: Boolean,
      default: () => false
    },
    maxWidth: {
      type: String,
      default: () => '700px'
    },
    showModal: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    closeDialog () {
      this.$emit('update:showModal', false)
    }
  }
}

</script>

<style scoped>
.simple-modal {
  font-size: 1.125rem;
  line-height: 1.4em;
  font-weight: 300;
}

.actions-style {
  max-width: 259px;
  margin: 0 auto;
  padding-bottom: 20px !important;
}

.border {
  border-radius: 10px;
}

.white-text {
  color: white !important;
}
</style>
